import { types as coreTypes } from '@sitebuilder/core';

export interface IResourceApiClient {
    getResources(): Promise<{ [key: string]: string } | null>;
}

export class ResourceApiClient implements IResourceApiClient {
    baseUrl: string;
    constructor(baseUrl: string = '') {
        this.baseUrl = baseUrl;
    }

    private getHeaders(
        h: {
            [key: string]: string;
        },
        options?: { accessToken?: string }
    ) {
        const headers: {
            [key: string]: string;
        } = {};

        if (typeof options?.accessToken === 'string' && options.accessToken.length > 0) {
            headers.Authorization = `bearer ${options.accessToken}`;
        }

        return { ...headers, ...h };
    }

    async getResources() {
        const url = `${this.baseUrl || ''}/api/resources/`;

        const res = await fetch(url, {
            method: 'GET',
            headers: this.getHeaders({}),
        });

        const resources = res.ok ? await res.json() : null;
        return resources;
    }

    async saveResources(
        resources: coreTypes.Resources,
        options?: { originalHostname?: string; accessToken?: string }
    ) {
        const url = `${this.baseUrl || ''}/api/admin/resources`;

        await fetch(url, {
            method: 'POST',
            headers: this.getHeaders(
                {
                    'Content-Type': 'application/json',
                },
                options
            ),
            body: JSON.stringify(resources),
        });
    }

    async importResources(
        fileData: any,
        options?: { originalHostname?: string; accessToken?: string }
    ) {
        const url = `${this.baseUrl || ''}/api/admin/resources/uploadResources`;

        const res = await fetch(url, {
            method: 'POST',
            headers: this.getHeaders({}, options),
            body: fileData,
        });

        const resources = await res.json();
        return resources;
    }
}
